var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.925 7.19995L6.25311 14.905C3.67499 15.4617 1.79999 17.7761 1.79999 20.4128V22.2878H5.54999V48.5378H1.79999V52.2878H58.05V48.5378H54.3V22.2878H58.05V20.4128C58.05 17.7761 56.175 15.4763 53.7873 14.9636L29.925 7.19995ZM29.925 11.1257L52.6887 18.5378H7.17597C7.19061 18.5378 7.20526 18.5378 7.21991 18.5378L29.925 11.1257ZM9.29999 22.2878H13.05V48.5378H9.29999V22.2878ZM16.8 22.2878H20.55V48.5378H16.8V22.2878ZM24.3 22.2878H28.05V48.5378H24.3V22.2878ZM31.8 22.2878H35.55V48.5378H31.8V22.2878ZM39.3 22.2878H43.05V48.5378H39.3V22.2878ZM46.8 22.2878H50.55V48.5378H46.8V22.2878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI1);
export default __webpack_public_path__ + "static/media/i1.a6745f26ce389a206606da1dd0847c02.svg";
export { ForwardRef as ReactComponent };